import { Button, Col, FormControl, FormLabel, Row } from "react-bootstrap";
import { ErroMsg, formatarComoDecimal, formatarComoMoeda, formatarData, MemoShow, SucessoMsg } from "../../contents/VariaveisGlobais";
import { DivBorder, DivBorderDados, BlackFontTrello, BlackFont, RowBorder, NormalFont, RedFont, RedFontTrello } from "./styles";
import UltimasCompras from "../UltimasCompras";
import { ConsultaTotvsEmpresa } from "../../../backend/ConsultaTotvsEmpresa";
import { handleAbrirMapa, handleAbrirSC } from "./Pedido";
import { toast } from "react-toastify";
import ConsumoTOTVS_POST from "../../../backend/ConsumoTotvs";

var campoMotivoBMItem = "";

function handleSituacaoFila(item){
    let status = ''
    
    switch (item.value){
        case '01':
            status = 'Pendente';
            break;
        case '02':
            status = 'Aguardando Aprovação';
            break;
        case '03':
            status = 'Aprovado';
            break;
        case '04':
            status = 'Bloqueado pelo Usuário';
            break;
        case '05':
            status = 'Aprovado pelo outro usuário';
            break;
        case '06':
            status = 'Reprovado pelo Usuário';
            break;
        case '07':
            status = 'Reprovado pelo outro usuário';
            break;
        default:
            status = 'Indefinido';
            break;
    }

    return (<div>{status}</div>);
}

function handleFilialAprovacao(item){
    return (
        <p>
            <span className="d-flex justify-content-between">
                <span><strong>Filial.: </strong> {item.CR_FILIAL}</span>
                <span><strong>Tp. Aprovação: </strong> {item.CR_TIPO}</span>                
            </span>
        </p>)
}

function handleNumeroAprovacao(item, acessor, header, data, setData, disabled, DisparaBootBox, FechaBootBox){
    const { C7_NUMCOT, EMPRESA, CR_FILIAL } = item;
    let cNomeNumero = 'Pedido'
    switch (item.TIPODOC) {
        case 'MD':         
            cNomeNumero = 'Medição'
            break;    
        case 'SP':         
            cNomeNumero = 'Sol. Pagto'
            break;    
        case 'SC':         
            cNomeNumero = 'SC'
            break;    
        case 'IS':
            cNomeNumero = 'SC'
            break;    
        case 'CP':
            cNomeNumero = 'CP'
            break;    
        case 'NF':
            cNomeNumero = 'NF'
            break;    
        case 'BM':
            cNomeNumero = 'BMSI'
            break;    
        default:
            break;
    }
    
    return (<>
        <p>
            <span className="d-flex justify-content-between">
                <span><strong>{cNomeNumero}: </strong> {cNomeNumero === "NF" ? item.NUMERO : item.CR_NUM.substr(0,6)}</span>
                <span><strong>Emissão: </strong> {formatarData(item.EMISSAO)}</span>                
            </span>
        </p>
        { C7_NUMCOT && C7_NUMCOT.trim() && <p><BlackFont tooltipText={"Abrir Mapa de Cotação"} style={{padding: "0px"}} onClick={()=> handleAbrirMapa(EMPRESA, CR_FILIAL, C7_NUMCOT, DisparaBootBox, FechaBootBox) }><strong>Cotação: </strong>{C7_NUMCOT}</BlackFont></p> }
    </>)
}

function handleSerieAprovacao(item){
    const TipoNF = [   
        { value: 'N', label: 'NF Normal'},
        { value: 'C', label: 'Compl. Preço' },
        { value: 'D', label: 'Devolução' },
        { value: 'I', label: 'NF Compl. ICMS' },
        { value: 'P', label: 'NF Compl. IPI' },
        { value: 'B', label: 'NF Beneficiamento' }
    ]
     
    const TipoDesc = TipoNF.filter( (itemTipo) => itemTipo.value === item.OBS )[0].label

    return (
        <>
            <p>
                <span className="d-flex justify-content-between">
                    <span><strong>Serie: </strong> {item.SALDO}</span>
                    <span><strong>Dt. Digitação: </strong> {formatarData(item.SOLICITANTE)}</span>                
                </span>
            </p>
            <p>
                <span className="d-flex justify-content-between">
                    <span><strong>Tipo: </strong> {TipoDesc}</span>
                    <span><strong>Espécie: </strong> {item.OBSAUX}</span>
                </span>
            </p>
        </>
    )
}

function handleInclusao(item){
    return <p><strong>Data Inclusão: </strong>{formatarData(item.CR_EMISSAO)}</p>
}

function handleFornecedorAprovacao(item){
    return <p><strong>Fornecedor: </strong>{item.CODIGO + "/" + item.LOJA + " - " + item.NOME + ' (' + item.CGC + ')'}</p>
}

function handleCompradorAprovacao(item){
    if ('IS|SC'.includes(item.TIPODOC)){
        return <>
            <p><strong>Sol.: </strong> {item.SOLICITANTE}</p> 
            <p><strong>Comprador: </strong>{item.COMPRADOR + " - " + item.NOMECOMPRADOR}</p>
        </>
    }else{
        return <p><strong>Comprador: </strong>{item.COMPRADOR + " - " + item.NOMECOMPRADOR}</p>
    }
    
}

function handleCondicaoPagamento(item){
    return <p><strong>Cond. Pagto: </strong>{item.CONDPG + " - " + item.E4_DESCRI}</p>
}

function handleOBSMedicao(item) {
    const isExpanded = item.isExpanded;
    return isExpanded ? <p><strong>Observação: </strong>{MemoShow(item.OBSMED)}</p> : '';
}

function handleMemo(item){
    const isExpanded = item.isExpanded;
    return isExpanded ? (
        <div style={{ marginBottom: '8px' }}>
            <Row>
                <Col md="6" xs="12">
                    <strong>Objeto: </strong>{MemoShow(item.value, 10)}
                </Col>
                <Col md="6" xs="12">
                    <strong>Justificativa: </strong>{MemoShow(item.CN9_CODJUS, 10)}
                </Col>
            </Row>
        </div>) : '';
}

function handleObservacao(item){
    const isExpanded = item.isExpanded;
    return isExpanded ? (
        <div style={{ marginBottom: '8px' }}>
            <Row>
                <Col md="6" xs="12">
                    <strong>Observação Fornecedor: </strong>
                    {MemoShow(item.OBS)}
                </Col>
                <Col md="6" xs="12">
                    <strong>Justificativa: </strong>
                    {MemoShow(item.OBSAUX)}
                </Col>
            </Row>
        </div>
    ) : '';
}

function handleProdutoAprovacaoCP(item, acessor, header, data, setData, disabledForm, AbreBox, FechaBox){
    return  ( 
        <>
            {item.index === 0 && (
                <Row>
                    <DivBorder md="5">
                        <strong>Item </strong>
                    </DivBorder> 
                    <DivBorder md="1">
                        <strong>Qtde. </strong>
                    </DivBorder> 
                    <DivBorder md="1">
                        <strong>Valor Unitário </strong>
                    </DivBorder> 
                    <DivBorder md="2">
                        <strong>Valor Total </strong>                
                    </DivBorder> 
                    <DivBorder md="3">
                        <strong>Prazo / Armazém / CC</strong>
                    </DivBorder> 
                </Row>
            )}
            <RowBorder>
                <DivBorderDados md="5">
                    <p><strong>Item:</strong> {item.ITEM}</p>
                    <p><strong>Produto:</strong> {item.PRODUTO.trim() + " - " + item.DESCRICAO.trim()} </p>
                    { item.OBS && item.OBS.trim() && (<p><strong>Desc. Compl.:</strong> {item.OBS}</p>)}
                    { item.NUMSC && item.NUMSC.trim() && (<p><strong>C.A.:</strong> {item.NUMSC}</p>)}
                </DivBorderDados> 
                <DivBorderDados md="1">
                    {formatarComoDecimal(item.QUANT,4)}
                </DivBorderDados> 
                <DivBorderDados md="1">
                    <p>{formatarComoMoeda(item.PRECO,4)}</p>
                </DivBorderDados> 
                <DivBorderDados md="2">
                    {formatarComoMoeda(item.TOTAL,2)}               
                </DivBorderDados> 
                <DivBorderDados md="3">
                    <p><strong>Prazo Entrega (Dias):</strong> {item.ITEMSC}</p>
					{ item.LOCAL && item.LOCAL.trim() && item.CC && item.CC.trim() && (<p><strong>Armazém:</strong> {item.LOCAL.trim() + " - " + item.SOLICITANTE.trim()}</p> ) }
					{ item.CC && item.CC.trim() && (<p><strong>CC:</strong> {item.CC.trim() + " - " + item.CCDESC.trim()}</p>) }
                </DivBorderDados> 
            </RowBorder>            
        </>
    )
}

function handleProdutoAprovacaoBM(item, acessor, header, data, setData, disabledForm, AbreBox, FechaBox){
    const empresaFilial = item.EMPRESA + '-' + item.CR_FILIAL

    return  ( 
        <>
            {item.index === 0 && (
                <Row>
                    <DivBorder md="2">
                        <strong>Empresa/Item </strong>
                    </DivBorder> 
                    <DivBorder md="4">
                        <strong>C.Custo/Conta Débito </strong>
                    </DivBorder> 
                    <DivBorder md="1">
                        <strong>Qtde. </strong>
                    </DivBorder> 
                    <DivBorder md="2">
                        <strong>Valor Unitário </strong>
                    </DivBorder> 
                    <DivBorder md="2">
                        <strong>Valor Total </strong>                
                    </DivBorder> 
                    <DivBorder md="1">
                        <strong>Ações </strong>
                    </DivBorder> 
                </Row>
            )}
            <RowBorder>
                <DivBorderDados md="2">
                    <p><strong>Item:</strong> {item.ITEM}</p>
					<p><strong>Empresa:</strong> {item.CONDPG}</p>
                </DivBorderDados> 
                <DivBorderDados md="4">
					<p><strong>CC:</strong> {item.NUMSC.trim() + " - " + item.ITEMSC.trim()}</p>
					<p><strong>Conta:</strong> {item.SOLICITANTE.trim() + " - " + item.NOMEREDUZ.trim()}</p>
					<p><strong>Detalhe:</strong> {item.OBS}</p>
                </DivBorderDados> 
                <DivBorderDados md="1">
                    {formatarComoDecimal(item.QUANT,4)}
                </DivBorderDados> 
                <DivBorderDados md="2">
                    <p>{formatarComoMoeda(item.PRECO,4)}</p>
                </DivBorderDados> 
                <DivBorderDados md="2">
                    {formatarComoMoeda(item.TOTAL,2)}               
                </DivBorderDados> 
                <DivBorderDados md="1">
					<RedFontTrello onClick={(e) => handleReprovaItemBM(item, data, setData, AbreBox, FechaBox)}>Reprovar</RedFontTrello>
                </DivBorderDados> 
            </RowBorder>            
        </>
    )
}

function handlePrioridadeCP(item){
    const options = [
        {
            value: '1',
            text: "Normal",
        },
        {
            value: '2',
            text: "Regularização",
        },
        {
            value: '3',
            text: "Emergencial",
        },
        {
            value: '5',
            text: "Reposição",
        },
        {
            value: '6',
            text: "Compra Direta",
        }
    ];
    
    const prioridade = options.filter( (option) => option.value === (item.value || "1"))[0].text;

    return prioridade
}

function handleProdutoAprovacao(item, acessor, header, data, setData, disabledForm, AbreBox, FechaBox){
    const options = [
        {
            value: '1',
            text: "Normal",
        },
        {
            value: '2',
            text: "Regularização",
        },
        {
            value: '3',
            text: "Emergencial",
        },
        {
            value: '5',
            text: "Reposição",
        },
        {
            value: '6',
            text: "Compra Direta",
        }
    ];
    
    const prioridade = item.TIPODOC === "PC" ? options.filter( (option) => option.value === (item.TIPOCOMPRA || "1"))[0].text : "";
    const empresaFilial = item.EMPRESA + '-' + item.CR_FILIAL

    return  ( 
        <>
            {item.index === 0 && (
                <Row>
                    <DivBorder md="1">
                        <strong>Item </strong>
                    </DivBorder> 
                    <DivBorder md={item.TIPODOC === "PC" ? "3" : "4"}>
                        <strong>Produto </strong>
                    </DivBorder> 
                    { item.TIPODOC === 'PC' && (
                        <DivBorder md="1">
                            <strong>Prioridade</strong>
                        </DivBorder>                     
                    )}
                    <DivBorder md="2">
                        <strong>C. Custo </strong>
                    </DivBorder>                     
                    <DivBorder md="1">
                        <strong>Qtde. </strong>
                    </DivBorder> 
                    <DivBorder md="2">
                        <strong>Valor Unitário </strong>
                    </DivBorder> 
                    <DivBorder md="2">
                        <strong>Valor Total </strong>                
                    </DivBorder> 
                </Row>
            )}
            <RowBorder>
                <DivBorderDados md="1">
                    {item.ITEM}
                </DivBorderDados> 
                <DivBorderDados md={item.TIPODOC === "PC" ? "3" : "4"}>
                    { 
                        <>
                            <BlackFontTrello tooltipText={`Ultimas Compras Produto: ${item.PRODUTO}`} onClick={(e) => handleHistoricoProduto(item.PRODUTO, empresaFilial, AbreBox, FechaBox)} >({item.PRODUTO})</BlackFontTrello> { " - " + item.DESCRICAO + ' (' + item.UM + ')'}
                            {item.TIPODOC === "PC" && item.NUMSC && item.NUMSC.trim() && ( <><br/><BlackFontTrello tooltipText={`Solicitação de Compras: ${item.NUMSC}`} onClick={(e) => handleAbrirSC(item.EMPRESA, empresaFilial, item.NUMSC, AbreBox, FechaBox)} >SC: {item.NUMSC}-{item.ITEMSC}</BlackFontTrello></>) }
                            {item.TIPODOC === "NF" && item.NUMSC && item.NUMSC.trim() && ( <><br/><BlackFontTrello tooltipText={`Pedido de Compras: ${item.NUMSC}`} >PC: {item.NUMSC}-{item.ITEMSC}</BlackFontTrello></>)}
                        </>
                    }
                </DivBorderDados> 
                { item.TIPODOC === 'PC' && (
                    <DivBorderDados md="1">
                        {prioridade}
                    </DivBorderDados> 
                )}
                <DivBorderDados md="2">
                    {item.CC + " - " + item.CCDESC}
                    { !('NF|IS|SC'.includes(item.TIPODOC)) && item.SOLICITANTE && item.SOLICITANTE.trim() && (
                        <p><strong>Sol.: </strong> {item.SOLICITANTE}</p> 
                    )}
                    { ('NF'.includes(item.TIPODOC)) && item.PS9_NATUR && item.PS9_NATUR.trim() && (
                        <p><strong>Finalidade: </strong> {item.PS9_NATUR}</p> 
                    )}
                </DivBorderDados> 
                <DivBorderDados md="1">
                    {formatarComoDecimal(item.QUANT,4)}
                </DivBorderDados> 
                <DivBorderDados md="2">
                    <p>{formatarComoMoeda(item.PRECO,4)}</p>
                </DivBorderDados> 
                <DivBorderDados md="2">
                    {formatarComoMoeda(item.TOTAL,2)}               
                </DivBorderDados> 
            </RowBorder>            
        </>
    )
}

function handleVenctoValor(item){
    return (<p>
                <span className="d-flex justify-content-between">
                    <span><strong>Vencto: </strong> {formatarData(item.NECESSIDADE)}</span>
                    <span><strong>Valor: </strong> {formatarComoMoeda(parseFloat(item.CR_TOTAL), 2)}</span>                
                </span>
            </p>)
}

function handleCentroCusto(item){
    return <p><strong>C. Custo: </strong>{item.CC + " - " + item.CCDESC}</p>
}

function handleTitulo(item){
    return (
        <p>
            <span className="d-flex justify-content-between">
                <span><strong>Título: </strong>{item.UM + " - " + item.QUANT}</span>
                <span><strong>Natureza: </strong>{item.NOMECOMPRADOR}</span>
            </span>
        </p>)
}

function handleNumeroContratoAprovacao(item){
    return (
        <p>
            <span className="d-flex justify-content-between">
                <span><strong>Número: </strong> {item.CR_NUM.substr(0,15)}</span>
                <span><strong>Rev: </strong> {item.LOCAL}</span>                
            </span>
        </p>)
}

function handleSaldoAprovacao(item){
    return (
        <p>
            <span className="d-flex justify-content-between">
                <span><strong>Valor: </strong> {formatarComoMoeda(item.CR_TOTAL,2)}</span>
                <span><strong>Saldo: </strong> {formatarComoMoeda(item.SALDO,2)}</span>                
            </span>
        </p>)
}

function handleContratoMedicaoAprovacao(item){
    return (
        <p>
            <span className="d-flex justify-content-between">
                <span><strong>Contrato: </strong> {item.OBSAUX}</span>
                <span><strong>Rev.: </strong> {item.TIPOCOMPRA}</span>                
            </span>
        </p>)
}

function handleDescricaoMedicaoAprovacao(item){
    return (
        <p>
            <span className="d-flex justify-content-between">
                <span><strong>Descrição: </strong> {item.OBS}</span>
                <span><strong>Saldo: </strong> {formatarComoMoeda(item.SALDO,2)}</span>                
            </span>
        </p>)
}

async function handleReprovaItemBM(bmsi, data, setData, DisparaBootBox, FechaBootBox){
    const idRow = bmsi.NUMERO + '' + bmsi.ITEM + '|' + bmsi.EMPRESA + '|' + bmsi.CR_FILIAL + '|' + bmsi.CR_TIPO + '|' + bmsi.CR_APROV + '|' + bmsi.CR_USER;
    const Mensagem = ( <>
            <FormLabel>Motivo Rejeição</FormLabel>
            <FormControl
                type='text'
                onChange={handleCampoMotivoBMItem}
            />
        </>
    )

    const buttonsRender = [
        { variant: 'primary', action: (e) => handleConfirmaRejeicaoBMItem(idRow, bmsi, data, setData, FechaBootBox), label: '✓ Confirmar' },
        { variant: 'secondary', action: FechaBootBox, label: '✗ Cancelar' }
    ]

    campoMotivoBMItem = ''

    await DisparaBootBox('Confirma Rejeição ?', Mensagem, buttonsRender, idRow, null)
}

const handleCampoMotivoBMItem = (e) =>{
    campoMotivoBMItem = e.target.value
}

const handleConfirmaRejeicaoBMItem = async(id, item, data, setData, FechaBootBox) =>{
    if (!campoMotivoBMItem){
        toast.warning('O prenchimento do Motivo da Rejeição é obrigatório.');
        return
    }
    
    const [ BMSI, EMPRESA, FILIAL, TIPO, APROV, USER ] = id.split('|')

    let jsonAprova = {
        EMPRESA: EMPRESA,
        FILIAL: FILIAL,
        TIPOFILA: TIPO,
        NUMERO: BMSI,
        APROVADOR: APROV,
        USUARIO: USER,
        JUSTIFICATIVA : campoMotivoBMItem,
        TIPO : "R",
        VALOR: item.TOTAL,
        CHAVESCR: item.CR_NUM,
        CHAVEDBM: item.ITEM,
    }
    
    let cJSONAprova = JSON.stringify(jsonAprova)
    
    const retornoAprovacao = await ConsumoTOTVS_POST( 'APROVABMSI', cJSONAprova, EMPRESA + FILIAL )

    if (retornoAprovacao.error !== '00'){
        ErroMsg('Falha na Aprovação! Erro: ' + retornoAprovacao.CR_NUM);
    }else{
        SucessoMsg("Reprovação do Item realizada com sucesso!");

        // Envia Email de Notificação
        toast.warning('EMAIL REPROVADO' + retornoAprovacao.EMAILCC );

        const dataAux = data.map( (itemMap) => { if (itemMap.item == item.item) { itemMap.ITENS.splice(item.index,1) } return itemMap } )
        setData(dataAux);
    }

    FechaBootBox()
}


async function handleHistoricoProduto(codigoProduto, empresaFilial, DisparaBootBox, FechaBootBox){
    let dataProdutos = [];

    let consulta = "SELECT TOP 100 B1_COD, B1_DESC, C7_CC, CTT_DESC01, C7_FILIAL, C7_NUM, C7_QUANT, C7_PRECO, C7_TOTAL, C7_EMISSAO, A2_COD + ' - ' + A2_LOJA FORNECE, A2_NOME "
    consulta += "FROM TABELA(SC7) SC7 "
    consulta += "INNER JOIN TABELA(SB1) SB1 ON B1_FILIAL = FILIAL(SB1) AND B1_COD = C7_PRODUTO AND SB1.D_E_L_E_T_ <> '*' "
    consulta += "INNER JOIN TABELA(SA2) SA2 ON A2_FILIAL = FILIAL(SA2) AND A2_COD = C7_FORNECE AND A2_LOJA = C7_LOJA AND SA2.D_E_L_E_T_ <> '*' "
    consulta += "INNER JOIN TABELA(CTT) CTT ON CTT_FILIAL = FILIAL(CTT) AND CTT_CUSTO = C7_CC AND CTT.D_E_L_E_T_ <> '*' "
    consulta += "WHERE SC7.D_E_L_E_T_ <> '*' "
    consulta += "AND C7_PRODUTO = '" + codigoProduto + "' "
    consulta += "ORDER BY C7_EMISSAO DESC "

    const retConsulta = await ConsultaTotvsEmpresa(consulta, 'SB1;SC7;SA2;CTT', empresaFilial)
    
    if (retConsulta.data){
        if (retConsulta.data.length > 0){
            dataProdutos = retConsulta.data;
            
            UltimasCompras( DisparaBootBox, FechaBootBox, dataProdutos);
        }else{
            toast.info('Não há dados de Compras Anteriores desse Produto')
        }
    }
}

export { handleSituacaoFila, handleDescricaoMedicaoAprovacao, handleContratoMedicaoAprovacao, handleSaldoAprovacao, handleNumeroContratoAprovacao, handleFilialAprovacao, handleNumeroAprovacao, handleFornecedorAprovacao, handleCompradorAprovacao, handleOBSMedicao, handleMemo, handleObservacao, handleProdutoAprovacao, handleVenctoValor, handleCentroCusto, handleTitulo, handleCondicaoPagamento, handleInclusao, handleSerieAprovacao, handleHistoricoProduto, handleProdutoAprovacaoBM, handleProdutoAprovacaoCP, handlePrioridadeCP }